module.exports = __webpack_public_path__ + "img/hzm-back.f30a06a4.png";